import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import React, { useState, useEffect } from 'react';

import CartItem from '../modules/CardCartItem';


import { CartX, Wallet, CashCoin } from 'react-bootstrap-icons';

import CheckoutForm from '../forms/Checkout';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import GenericFormContainer from '../forms/FormContainer';
import { INTRFUser } from '../../hooks/Interfaces';

interface ApplicationProps {
    user: INTRFUser;
    updatefunc: () => void;
}
interface PriceAdjustmentProps {
    name: string;
    discount: boolean;
    percentage: boolean;
    rate: number;

}
interface CartItemProps {
    inventory_id: string;
    name: string;
    image: string;
    price: number;
    quantity: number;
    total: number;
}

function CartPage({user, updatefunc}: ApplicationProps){
    /* For UI  */
    const [cartitems, setCartItems] = useState<CartItemProps[]>([]);
    const [priceadjustments, setPriceAdjustments] = useState<PriceAdjustmentProps[]>([]);

    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);


    const [checkout, setCheckout] = useState(false);
    const [loading, setLoading] = useState(true);

    const GetInventory = async () => {
        //setLoading(true);
        let axiosConfig = GetHeaders();
        const posturl = process.env.REACT_APP_API_URL + "/v1/commerce/cart"

        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: {}})
        //Handle a Non 200 response
        setCartItems(response.item_list)
        setPriceAdjustments(response.adjustments)
        setSubtotal(response.subtotal)
        setTotal(response.total)
    }

    /* Component Init */
    useEffect(() => {
        console.log("Initializing cart component.")

        GetInventory();    
    }, []);

    return (
        <> 
            <GenericFormContainer>
                { (!checkout) &&
                    <Row className="">
                        <Col md={{ span: 12, offset: 0 }}>
                            <table className="table">
                                <thead>
                                    <tr>
                                    <th className="col-1"><button type="button" className="btn btn-danger m-2 py-0"><CartX className="my-2" size={20} /></button></th>
                                    <th className="col-1"></th>
                                    <th className="col-2">Item</th>
                                    <th className="col-1"></th>
                                    <th className="col-1">Quantity</th>
                                    <th className="col-1"></th>
                                    <th className="col-2">Totals</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cartitems.map((item, index)  => 
                                            <CartItem
                                                itemid={item.inventory_id}
                                                name={item.name}
                                                image={item.image}
                                                quantity={item.quantity}
                                                total={item.total}
                                                price={item.price}
                                                appupdate={updatefunc}
                                            />
                                        )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                }

                <Row className="text-font-size-large">
                    <Col className="text-start">Subtotal:</Col>
                    <Col></Col>
                    <Col className="text-end "span={{}}>
                        ${subtotal.toFixed(2)}
                    </Col>
                </Row>
                <Row className="">
                    <Col>
                        {
                            priceadjustments.map((item, index)  => 
                                <Row className="">
                                    <Col className="text-start text-font-size-small"><p>{item.name}</p></Col>
                                    <Col span={{offset: 1}} className="text-start text-font-size-tiny">
                                        <p>
                                            (
                                            {item.discount ? "-" : "+"}
                                            {!item.percentage && "$"}
                                            {item.percentage ? item.rate : item.rate.toFixed(2)}
                                            {item.percentage && "%"}
                                            )
                                        </p>
                                    </Col>
                                    <Col className="text-end text-font-size-small">
                                        {item.discount && "-"}$
                                        {item.discount && item.percentage && (subtotal * (.01) * item.rate).toFixed(2)}
                                        {item.discount && !item.percentage && (item.rate).toFixed(2)}
                                        {!item.discount && item.percentage && (subtotal * (.01) * item.rate).toFixed(2)}
                                        {!item.discount && !item.percentage && (item.rate).toFixed(2)}
                                    </Col>
                                    
                                </Row>
                            )
                        }
                    </Col>
                </Row>
                <Row className="text-font-size-large">
                    <Col className="text-start">Total:</Col>
                    <Col></Col>
                    <Col className="text-end "span={{}}>
                        ${total.toFixed(2)}
                    </Col>
                </Row>
                { (!checkout) &&
                    <Row className="">
                        <Col>
                            
                            <button type="button" className="btn brand-btn-secondary-color m-2 py-1" onClick={() => setCheckout(true)}>
                                <Wallet className="mx-1" size={40} /><CashCoin className="mx-1" size={40} />
                            </button>
                        </Col>
                    </Row>
                }

                { (checkout) &&
                    <Row className="">
                            <Col className="" md={{ span: 12}}>
                                <CheckoutForm user={user} closefunc={setCheckout}/>
                            </Col>
                    
                    </Row>
                }
            </GenericFormContainer>
                 
                

                

        </>
    )
}

export default CartPage;